import { Component, CUSTOM_ELEMENTS_SCHEMA, Input, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from 'src/app/services/common.service';
import { FormsModule, ReactiveFormsModule, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { DropdownModule } from 'primeng/dropdown';
import { CommonModule } from '@angular/common';
import { IstDataShareService } from 'src/app/services/ist/ist-datashare.service';
import { GrantsDatashareService } from 'src/app/services/grants/grants-datashare.service';
import { EAPDatashareService } from 'src/app/services/eap/eap-datashare.service';
import { AdministrationSummaryService } from 'src/app/services/administration/administration-summary.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-select-applicationtype-model',
  standalone: true,
  imports: [CommonModule,
    FormsModule,
    ReactiveFormsModule, DropdownModule],
  //schemas:[CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './select-applicationtype-model.component.html',
  styleUrl: './select-applicationtype-model.component.scss'
})
export class SelectApplicationtypeModelComponent implements OnInit {
  @Input() public Content: any;
  ApplicationTypeList: any = [];
  CurrencyList: any[];
  applicationTypeForm: UntypedFormGroup;
  constructor(
    public modalRef: NgbActiveModal,
    private commonservice: CommonService,
    private summaryService: AdministrationSummaryService,
    private datashare: IstDataShareService,
    private grantsdatashare: GrantsDatashareService,
    private eapdatashare: EAPDatashareService,
    private userService: UserService,
  ) { }

  ngOnInit() {
    this.applicationTypeForm = new UntypedFormGroup({
      APPLICATION_TYPE_ID: new UntypedFormControl(""),
      CURRENCY: new UntypedFormControl(""),
    });
    this.getApplicationtypes();
    this.getCurrencyList();
  }

  showConfirm(): void {
    let appTypeID = this.applicationTypeForm.controls["APPLICATION_TYPE_ID"].value;
    let currencyID = this.applicationTypeForm.controls["CURRENCY"].value;
    if (!appTypeID || !currencyID) {
      this.commonservice.ValidationBanner("To proceed further, select application type ");
    }
    else {
      this.datashare.setApplication_Type_ID(this.applicationTypeForm.controls["APPLICATION_TYPE_ID"].value);
      this.datashare.setCurrency_ID(this.applicationTypeForm.controls["CURRENCY"].value);
      this.grantsdatashare.setApplication_Type_ID(this.applicationTypeForm.controls["APPLICATION_TYPE_ID"].value);
      this.grantsdatashare.setCurrency_ID(this.applicationTypeForm.controls["CURRENCY"].value);
      this.eapdatashare.setApplication_Type_ID(this.applicationTypeForm.controls["APPLICATION_TYPE_ID"].value);
      this.eapdatashare.setCurrency_ID(this.applicationTypeForm.controls["CURRENCY"].value);
      this.modalRef.close(this.applicationTypeForm.controls["APPLICATION_TYPE_ID"].value);
    }

  }
  CancelClcik(): void {
    this.modalRef.dismiss();
  }
  getApplicationtypes() {
    let submodule = "-1";
    if (this.Content.ModuleID == "4") {
      submodule = this.Content.SubModuleID;
    }
    this.commonservice.getAllApplicationTypes(this.Content.ModuleID, submodule).subscribe((result) => {
      if (result) {
        this.ApplicationTypeList = result;
      }
    });
  }

  getCurrencyList() {
    this.summaryService.getSummaryData('api/apptypes/GetCurrencyData')
      .subscribe((result) => {
        if (result) {
          this.CurrencyList = result["MasterData1"];
          this.userService.getCurrency().subscribe((res) => {
            const response = JSON.parse(res);
              this.applicationTypeForm.controls['CURRENCY']!.setValue(response.Data);
            
          });
        }
      });
  }
}
